import React, { useEffect } from 'react';
import { shallowEqual } from '@beef/utils';
import { usePrevious } from '@beef/react';
export var CrashedComponent = function CrashedComponent(_ref) {
  var componentProps = _ref.componentProps,
    onClearError = _ref.onClearError;
  var prevProps = usePrevious(componentProps);
  useEffect(function () {
    if (shallowEqual(componentProps, prevProps) || !prevProps) return;
    onClearError === null || onClearError === void 0 ? void 0 : onClearError();
  }, [componentProps, onClearError, prevProps]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#ee5555',
      padding: '10px',
      borderRadius: '8px'
    },
    "data-t-id": "utils-boundary"
  }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0440\u0435\u043D\u0434\u0435\u0440\u0438\u043D\u0433\u0435 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430");
};